"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87],{

/***/ 3785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ animateCameraZoom; },
/* harmony export */   "q": function() { return /* binding */ animateCamera; }
/* harmony export */ });
/* harmony import */ var _configs_CAMERA_CONFIG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7405);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6038);
/* harmony import */ var _store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8831);



const animateCamera = (camera)=>{
    if (camera === undefined || camera === null) return;
    const tl = gsap__WEBPACK_IMPORTED_MODULE_2__/* ["default"].timeline */ .ZP.timeline({
        onComplete: ()=>_store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__/* .useComponentLoadingStateStore.setState */ .C.setState({
                isCameraResetAnimationFinished: true
            })
    });
    tl.to(camera.position, {
        x: 0,
        y: 32.81719943867427,
        z: 101.00095444860476,
        duration: 1
    }, 0);
    tl.to(camera.rotation, {
        x: -0.3141592653589793,
        y: 0,
        z: 0,
        duration: 1
    }, 0);
};
const animateCameraZoom = (camera, zoomValue)=>{
    const isChangingHall = _store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__/* .useComponentLoadingStateStore.getState */ .C.getState().isCameraScrollZoomEnabled;
    const isChangingHallMobile = _store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__/* .useComponentLoadingStateStore.getState */ .C.getState().areControlPanelButtonsDisabled;
    if (isChangingHall || isChangingHallMobile) return;
    if (camera === undefined || camera === null) return;
    gsap__WEBPACK_IMPORTED_MODULE_2__/* ["default"].to */ .ZP.to(camera.position, {
        z: _configs_CAMERA_CONFIG__WEBPACK_IMPORTED_MODULE_0__/* .CAMERA_CONFIG.position[2] */ .Uf.position[2] - zoomValue,
        duration: 1
    });
};


/***/ }),

/***/ 1087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ fiber_components_Scene; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./configs/CAMERA_CONFIG.ts
var CAMERA_CONFIG = __webpack_require__(7405);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 2 modules
var react_three_fiber_esm = __webpack_require__(5029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(9226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(657);
;// CONCATENATED MODULE: ./components/MaterialCustomComponents/ControlPanelComponents.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: none;\n  position: absolute;\n  width: 100vw;\n  top: 0;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 24px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const ControlPanelWrapper = (0,styled/* default */.ZP)(Box/* default */.Z)(_templateObject());
const BootstrapDialog = (0,styled/* default */.ZP)(Dialog/* default */.Z)((param)=>{
    let {} = param;
    return {
        ".MuiDialog-paper": {
            maxWidth: "300px"
        }
    };
});

// EXTERNAL MODULE: ./animations/animateCamera.ts
var animateCamera = __webpack_require__(3785);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/index-6f0019d1.esm.js + 2 modules
var index_6f0019d1_esm = __webpack_require__(3932);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./components/fiber-components/ChangeCameraFiberComponent.tsx





const ChangeCameraFiberComponent = ()=>{
    const { query  } = (0,router.useRouter)();
    const { camera  } = (0,index_6f0019d1_esm.z)();
    (0,react.useEffect)(()=>{
        if (query.id) return;
        (0,animateCamera/* animateCamera */.q)(camera);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {});
};
/* harmony default export */ var fiber_components_ChangeCameraFiberComponent = (ChangeCameraFiberComponent);

// EXTERNAL MODULE: ./helpers/updateBoothURL.ts
var updateBoothURL = __webpack_require__(5270);
;// CONCATENATED MODULE: ./helpers/updateNextAndPreviousBoothURL.ts

const findBoothIndex = (booth, booths, direction)=>{
    var _splitName_;
    if (!booth || booths.length < 1 || !direction) return;
    let boothIndex = Number(booth.split("-")[1][1]);
    const splitName = booth.split("-")[1];
    const splitHall = booth.split("-")[0];
    const boothColumn = (_splitName_ = splitName[0]) === null || _splitName_ === void 0 ? void 0 : _splitName_.charCodeAt(0);
    const characterPositionInAscii = direction === "left" ? boothColumn - 1 : boothColumn + 1;
    let nextOrPreviousColumn = String.fromCharCode(characterPositionInAscii);
    if (nextOrPreviousColumn === "D") {
        boothIndex = Number(splitName[1]) + 1;
        nextOrPreviousColumn = "A";
    }
    if (nextOrPreviousColumn === "@") {
        boothIndex = boothIndex - 1;
        nextOrPreviousColumn = "C";
    }
    const boothFound = "".concat(splitHall, "-").concat(nextOrPreviousColumn).concat(boothIndex);
    if (boothFound === "".concat(splitHall, "-B5") && direction === "right") {
        return "".concat(splitHall, "-A6");
    }
    if (boothFound === "".concat(splitHall, "-C5") && direction === "left") {
        return "".concat(splitHall, "-A5");
    }
    if (boothFound === "".concat(splitHall, "-B6") && direction === "right") {
        return "".concat(splitHall, "-C6");
    }
    if (boothFound === "".concat(splitHall, "-B6") && direction === "left") {
        return "".concat(splitHall, "-A6");
    }
    if (boothFound === "".concat(splitHall, "-A7") && direction === "right") {
        return "".concat(splitHall, "-C5");
    }
    if (boothFound === "".concat(splitHall, "-A6") && direction === "right") {
        return undefined;
    }
    if (boothFound === "".concat(splitHall, "-B5") && direction === "left") {
        return "".concat(splitHall, "-C6");
    }
    for(let i = 0; i < booths.length; i++){
        if (boothFound === booths[i].name.toUpperCase()) {
            return booths[i].name.toUpperCase();
        }
    }
};
const updateNextAndPreviousBoothURL = (booth, booths, direction)=>{
    if (!booth || booths.length < 1 || !direction) return;
    const boothFound = findBoothIndex(booth, booths, direction);
    if (!boothFound) return;
    (0,updateBoothURL/* updateBoothURL */.xB)(null, boothFound);
};

// EXTERNAL MODULE: ./store/useRouterStore.ts
var useRouterStore = __webpack_require__(4049);
// EXTERNAL MODULE: ./store/useModelStore.ts
var useModelStore = __webpack_require__(9771);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./helpers/handleBoothHoverChanges.ts
var handleBoothHoverChanges = __webpack_require__(4516);
// EXTERNAL MODULE: ./store/useComponentLoadingStateStore.ts
var useComponentLoadingStateStore = __webpack_require__(8831);
;// CONCATENATED MODULE: ./animations/animateToBooth.ts





const target = new three_module.Vector3();
const findBoothPosition = (booth)=>{
    if (!booth) return;
    return booth.getWorldPosition(target);
};
const animateBoothsInTheMiddle = (camera, boothWorldPosition, boothSize, shouldRotate, isMobile, mobileOffsets)=>{
    const tl = gsap/* default.timeline */.ZP.timeline({
        onComplete: ()=>{
            useComponentLoadingStateStore/* useComponentLoadingStateStore.setState */.C.setState({
                isAnimateToBoothFinished: true
            });
        }
    });
    tl.to(camera.position, boothSize === "large" ? {
        x: boothWorldPosition.x + CAMERA_CONFIG/* CAMERA_OFFSETS.x */.lW.x,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + CAMERA_CONFIG/* CAMERA_OFFSETS.z */.lW.z,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    } : {
        x: boothWorldPosition.x + 1.5,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + 15,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    }, 0);
    if (!shouldRotate) return;
    tl.to(camera.rotation, {
        x: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.middle.rotation.x */.dH.middle.rotation.x,
        y: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.middle.rotation.y */.dH.middle.rotation.y,
        z: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.middle.rotation.z */.dH.middle.rotation.z,
        duration: 0.8
    }, 0.2);
};
const animateBoothsToTheRight = (camera, boothWorldPosition, boothSize, shouldRotate, isMobile, mobileOffsets)=>{
    const tl = gsap/* default.timeline */.ZP.timeline({
        onComplete: ()=>{
            useComponentLoadingStateStore/* useComponentLoadingStateStore.setState */.C.setState({
                isAnimateToBoothFinished: true
            });
        }
    });
    tl.to(camera.position, boothSize === "large" ? {
        x: boothWorldPosition.x - 7,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + 16,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    } : {
        x: boothWorldPosition.x - 3.5,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + 14,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    }, 0);
    if (!shouldRotate) return;
    tl.to(camera.rotation, {
        x: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.right.rotation.x */.dH.right.rotation.x,
        y: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.right.rotation.y */.dH.right.rotation.y,
        z: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.right.rotation.z */.dH.right.rotation.z,
        duration: 0.8
    }, 0.2);
};
const animateBoothsToTheLeft = (camera, boothWorldPosition, boothSize, shouldRotate, isMobile, mobileOffsets)=>{
    const tl = gsap/* default.timeline */.ZP.timeline({
        onComplete: ()=>{
            useComponentLoadingStateStore/* useComponentLoadingStateStore.setState */.C.setState({
                isAnimateToBoothFinished: true
            });
        }
    });
    tl.to(camera.position, boothSize === "large" ? {
        x: boothWorldPosition.x + 5,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + 17,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    } : {
        x: boothWorldPosition.x + 6.5,
        y: isMobile ? mobileOffsets.y : CAMERA_CONFIG/* CAMERA_OFFSETS.y */.lW.y,
        z: boothWorldPosition.z + 14,
        duration: 1,
        delay: 0.2,
        ease: "power4.out"
    }, 0);
    if (!shouldRotate) return;
    tl.to(camera.rotation, {
        x: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.left.rotation.x */.dH.left.rotation.x,
        y: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.left.rotation.y */.dH.left.rotation.y,
        z: CAMERA_CONFIG/* CAMERA_ROTATION_POSITION_OFFSETS.left.rotation.z */.dH.left.rotation.z,
        duration: 0.8
    }, 0.2);
};
const animateToBooth = function(camera, booth, boothSize) {
    let shouldRotate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isMobileBrowser = arguments.length > 4 ? arguments[4] : void 0;
    const mobileOffsets = {
        x: 0,
        y: 3,
        z: 15
    };
    useComponentLoadingStateStore/* useComponentLoadingStateStore.setState */.C.setState({
        isBrochurePartActive: false
    });
    (0,handleBoothHoverChanges/* handleBoothUnhover */.Px)(undefined, booth.children[0].children[0]);
    if (booth === undefined || camera === undefined || !boothSize) return;
    useComponentLoadingStateStore/* useComponentLoadingStateStore.setState */.C.setState({
        isAnimateToBoothFinished: false
    });
    const boothWorldPosition = findBoothPosition(booth);
    if (!boothWorldPosition) return;
    if (booth.position.z === -60 && booth.position.x !== 0) {
        animateBoothsInTheMiddle(camera, boothWorldPosition, boothSize, shouldRotate, isMobileBrowser, mobileOffsets);
        return;
    }
    if (booth.position.x === 0) {
        animateBoothsInTheMiddle(camera, boothWorldPosition, boothSize, shouldRotate, isMobileBrowser, mobileOffsets);
        return;
    }
    if (booth.position.x > 0) {
        animateBoothsToTheRight(camera, boothWorldPosition, boothSize, shouldRotate, isMobileBrowser, mobileOffsets);
        return;
    }
    if (booth.position.x < 0) {
        animateBoothsToTheLeft(camera, boothWorldPosition, boothSize, shouldRotate, isMobileBrowser, mobileOffsets);
        return;
    }
};

// EXTERNAL MODULE: ./animations/animateBlackBanner.ts
var animateBlackBanner = __webpack_require__(1948);
// EXTERNAL MODULE: ./animations/animateStripes.ts
var animateStripes = __webpack_require__(8752);
;// CONCATENATED MODULE: ./hooks/useMobileBrowser.ts

const useMobileBrowser = ()=>{
    const [isMobileBrowser, setIsMobileBrowser] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        function isMobileBrowser() {
            let check = false;
            (function(a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            if (check) {
                setIsMobileBrowser(true);
            } else {
                setIsMobileBrowser(false);
            }
        }
        window.addEventListener("resize", isMobileBrowser);
        isMobileBrowser();
        return ()=>window.removeEventListener("resize", isMobileBrowser);
    }, []);
    return {
        isMobileBrowser
    };
};

;// CONCATENATED MODULE: ./components/fiber-components/ChangeBoothFiberComponent.tsx












const ChangeBoothFiberComponent = ()=>{
    const { isBoothModelMounted , setIsBoothModelMounted , isHallTextureReady  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { boothID , arrowDirection , lastTriggeredAt , boothClickTriggeredFrom  } = (0,useRouterStore/* useRouterStore */.U)();
    const { booths  } = (0,useModelStore/* useModelStore */.V)();
    const { camera , scene  } = (0,index_6f0019d1_esm.z)();
    const { pathname  } = (0,router.useRouter)();
    const { isMobileBrowser  } = useMobileBrowser();
    (0,react.useEffect)(()=>{
        if (boothID === "" || booths.length <= 0) return;
        updateNextAndPreviousBoothURL(boothID, booths, arrowDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastTriggeredAt,
        (router_default()),
        arrowDirection
    ]);
    (0,react.useEffect)(()=>{
        const group = scene.getObjectByName(boothID);
        const isExpoPage = pathname.split("/")[1] === "expo";
        if (!isBoothModelMounted || !group || boothID === "") return;
        if (boothClickTriggeredFrom === "expo" || isExpoPage) {
            var _group_userData;
            if (!isHallTextureReady) return;
            animateToBooth(camera, group.children[0], (_group_userData = group.userData) === null || _group_userData === void 0 ? void 0 : _group_userData.standSize, true, isMobileBrowser);
            (0,animateBlackBanner/* animateHideBlackBanner */.R)();
        }
        if (boothClickTriggeredFrom === "global") {
            if (!isHallTextureReady) return;
            (0,animateStripes/* closeStripes */.v)(()=>{
                var _group_userData;
                animateToBooth(camera, group.children[0], (_group_userData = group.userData) === null || _group_userData === void 0 ? void 0 : _group_userData.standSize, true, isMobileBrowser);
            });
            (0,animateBlackBanner/* animateHideBlackBanner */.R)();
        }
        setIsBoothModelMounted(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isBoothModelMounted,
        boothID,
        pathname,
        isHallTextureReady,
        isMobileBrowser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {});
};
/* harmony default export */ var fiber_components_ChangeBoothFiberComponent = (ChangeBoothFiberComponent);

;// CONCATENATED MODULE: ./configs/HALL_ID_CONFIG.ts
const MINIMUM_HALL_ID = 0;
const MAXIMUM_HALL_ID = 7;

// EXTERNAL MODULE: ./configs/ARROWS_DIRECTION_CONFIG.ts
var ARROWS_DIRECTION_CONFIG = __webpack_require__(5131);
// EXTERNAL MODULE: ./configs/HALLS_CONFIG.ts
var HALLS_CONFIG = __webpack_require__(8767);
;// CONCATENATED MODULE: ./animations/animateHallChange.ts

const animateRightHallChange = function(camera) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    const tl = gsap/* default.timeline */.ZP.timeline({
        onComplete: ()=>{
            if (!cb) return;
            cb();
        }
    });
    tl.to(camera.position, {
        z: 103,
        duration: 0.3
    });
    tl.to(camera.position, {
        x: 10,
        duration: 0.6
    }, 0.6);
    tl.to(".black-bg-banner", {
        opacity: 1,
        duration: 0.6,
        onComplete: ()=>{
            camera.position.z = 102;
            camera.position.x = 0;
        }
    }, 0.6);
};
const animateLeftHallChange = function(camera) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    const tl = gsap/* default.timeline */.ZP.timeline({
        onComplete: ()=>{
            if (!cb) return;
            cb();
        }
    });
    tl.to(camera.position, {
        z: 103,
        duration: 0.3
    });
    tl.to(camera.position, {
        x: -10,
        duration: 0.6
    }, 0.6);
    tl.to(".black-bg-banner", {
        opacity: 1,
        duration: 0.6,
        onComplete: ()=>{
            camera.position.z = 102;
            camera.position.x = 0;
        }
    }, 0.6);
};

;// CONCATENATED MODULE: ./components/fiber-components/ChangeHallFiberComponent.tsx










const ChangeHallFiberComponent = ()=>{
    const { hallID , arrowDirection , setArrowDirection , lastTriggeredAt  } = (0,useRouterStore/* useRouterStore */.U)();
    const { camera  } = (0,index_6f0019d1_esm.z)();
    (0,react.useEffect)(()=>{
        if (!lastTriggeredAt || arrowDirection === "" || !hallID) return;
        if ((router_default()).query[HALLS_CONFIG/* HALL_ID */.P8] && !(router_default()).query.id) {
            const id = Number(hallID);
            if (arrowDirection === ARROWS_DIRECTION_CONFIG/* LEFT */.R && id > MINIMUM_HALL_ID) {
                animateLeftHallChange(camera, ()=>{
                    (0,updateBoothURL/* updateHallURL */.GU)(String(id === MINIMUM_HALL_ID + 1 ? id : id - 1));
                    setArrowDirection("");
                });
            }
            if (arrowDirection === ARROWS_DIRECTION_CONFIG/* RIGHT */.p && id < MAXIMUM_HALL_ID) {
                animateRightHallChange(camera, ()=>{
                    (0,updateBoothURL/* updateHallURL */.GU)(String(id === MAXIMUM_HALL_ID - 1 ? id : id + 1));
                    setArrowDirection("");
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastTriggeredAt,
        arrowDirection,
        hallID,
        (router_default())
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {});
};
/* harmony default export */ var fiber_components_ChangeHallFiberComponent = (ChangeHallFiberComponent);

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(3321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./components/GenericLayout/LeftArrowIcon.tsx
var LeftArrowIcon = __webpack_require__(2749);
// EXTERNAL MODULE: ./components/GenericLayout/RightArrowIcon.tsx
var RightArrowIcon = __webpack_require__(8625);
// EXTERNAL MODULE: ./components/MaterialCustomComponents.ts
var MaterialCustomComponents = __webpack_require__(4974);
;// CONCATENATED MODULE: ./components/NavigationMenu/ArrowNavigation.tsx













const ArrowNavigation = (param)=>{
    let { isDeviceOnLandscape =false  } = param;
    const { setIsInfoCategoryClicked , setHallZoomValue , isBoothVisitPartActive , setIsVideoClicked , isExpoPageLoaded , areControlPanelButtonsDisabled , setAreControlPanelButtonsDisabled  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { setArrowDirection , newTrigger , hallID , boothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const { booths  } = (0,useModelStore/* useModelStore */.V)();
    (0,react.useEffect)(()=>{
        if (!isExpoPageLoaded) return;
        setAreControlPanelButtonsDisabled(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isExpoPageLoaded
    ]);
    const handleChangeButtons = (direction)=>{
        if (boothID === "") {
            setAreControlPanelButtonsDisabled(true);
        }
        setHallZoomValue(0);
        setIsVideoClicked(false);
        setIsInfoCategoryClicked("");
        setArrowDirection(direction);
        newTrigger();
    };
    const splitBoothID = (booth, direction)=>{
        if (boothID === "") {
            return true;
        }
        if (direction === "left") {
            const hasBoothToTheLeft = findBoothIndex(booth, booths, "left");
            return hasBoothToTheLeft ? true : false;
        }
        if (direction === "right") {
            const hasBoothToTheRight = findBoothIndex(booth, booths, "right");
            return hasBoothToTheRight ? true : false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
        sx: {
            pointerEvents: "none",
            display: "flex",
            justifyContent: "space-between"
        },
        children: !isBoothVisitPartActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                splitBoothID(boothID, "left") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "controlPanel",
                    onClick: ()=>handleChangeButtons(ARROWS_DIRECTION_CONFIG/* LEFT */.R),
                    disabled: areControlPanelButtonsDisabled || (Number(hallID) === 1 && boothID === "" ? true : false),
                    sx: {
                        width: isDeviceOnLandscape ? "20px" : null,
                        height: isDeviceOnLandscape ? "40px" : null
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowIcon/* default */.Z, {
                        width: isDeviceOnLandscape ? 15 : 25,
                        height: isDeviceOnLandscape ? 15 : 30
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {}),
                Number(hallID) === 6 && boothID === "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "controlPanel",
                    sx: {
                        color: "white",
                        width: "120px",
                        height: "90px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap"
                    },
                    onClick: ()=>(0,animateStripes/* openStripes */.J)(()=>{
                            (0,updateBoothURL/* updateRoute */.fq)("/conference_hall");
                        }),
                    disabled: areControlPanelButtonsDisabled ? true : false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#ffffff"
                            },
                            children: "Conference Hall"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon/* default */.Z, {
                            width: 20,
                            height: 20
                        })
                    ]
                }) : splitBoothID(boothID, "right") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "controlPanel",
                    onClick: ()=>handleChangeButtons(ARROWS_DIRECTION_CONFIG/* RIGHT */.p),
                    disabled: areControlPanelButtonsDisabled ? true : false,
                    sx: {
                        width: isDeviceOnLandscape ? "20px" : null,
                        height: isDeviceOnLandscape ? "40px" : null
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon/* default */.Z, {
                        width: isDeviceOnLandscape ? 15 : 25,
                        height: isDeviceOnLandscape ? 15 : 30
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {})
            ]
        })
    });
};
/* harmony default export */ var NavigationMenu_ArrowNavigation = (ArrowNavigation);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./configs/NAVIGATION_PAGES.tsx + 9 modules
var NAVIGATION_PAGES = __webpack_require__(8183);
// EXTERNAL MODULE: ./components/NavigationMenu/NavigationCustomComponents.ts
var NavigationCustomComponents = __webpack_require__(7217);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(6336);
;// CONCATENATED MODULE: ./components/fiber-components/SingleBoothViewFiberComponent.tsx







const SingleBoothViewFiberComponent = ()=>{
    const { isBoothVisitPartActive , isSingleBoothViewButtonPressed , setIsBoothVisitPartActive , setIsSingleBoothViewButtonPressed  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { boothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const { camera , scene  } = (0,index_6f0019d1_esm.z)();
    const { isMobileBrowser  } = useMobileBrowser();
    (0,react.useEffect)(()=>{
        var _activeBooth_children__parent;
        if (!isBoothVisitPartActive || !isSingleBoothViewButtonPressed || !boothID) return;
        const activeBooth = scene.getObjectByName(boothID);
        animateToBooth(camera, activeBooth === null || activeBooth === void 0 ? void 0 : activeBooth.children[0], (_activeBooth_children__parent = activeBooth === null || activeBooth === void 0 ? void 0 : activeBooth.children[0].parent) === null || _activeBooth_children__parent === void 0 ? void 0 : _activeBooth_children__parent.userData.standSize, true, isMobileBrowser);
        setIsBoothVisitPartActive(false);
        setIsSingleBoothViewButtonPressed(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isBoothVisitPartActive,
        isSingleBoothViewButtonPressed,
        boothID,
        isMobileBrowser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {});
};
/* harmony default export */ var fiber_components_SingleBoothViewFiberComponent = (SingleBoothViewFiberComponent);

;// CONCATENATED MODULE: ./components/GenericLayout/MapIconSVG.tsx

const MapIconSVG = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.1514 22.3999L2.6665 26.6666V9.59992L11.1514 5.33325M11.1514 22.3999L20.8483 26.6666M11.1514 22.3999V5.33325M20.8483 26.6666L29.3332 22.3999V5.33325L20.8483 9.59992M20.8483 26.6666V9.59992M20.8483 9.59992L11.1514 5.33325",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var GenericLayout_MapIconSVG = (MapIconSVG);

;// CONCATENATED MODULE: ./components/GenericLayout/BackButtonSVG.tsx

const BackButtonSVG = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25px",
        height: "25px",
        viewBox: "0 0 25 25",
        version: "1.1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "surface1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                style: {
                    stroke: "none",
                    fillRule: "nonzero",
                    fill: "rgb(100%,100%,100%)",
                    fillOpacity: 1
                },
                d: "M 25 14.300781 C 25 17.144531 23.871094 19.871094 21.863281 21.878906 C 19.851562 23.886719 17.128906 25.015625 14.285156 25.015625 L 1.339844 25.015625 C 0.984375 25.015625 0.644531 24.875 0.390625 24.625 C 0.140625 24.375 0 24.03125 0 23.675781 C 0 23.324219 0.140625 22.980469 0.390625 22.730469 C 0.644531 22.480469 0.984375 22.339844 1.339844 22.339844 L 14.285156 22.339844 C 16.417969 22.339844 18.460938 21.492188 19.96875 19.984375 C 21.472656 18.476562 22.320312 16.433594 22.320312 14.300781 C 22.320312 12.171875 21.472656 10.128906 19.96875 8.621094 C 18.460938 7.113281 16.417969 6.265625 14.285156 6.265625 L 4.570312 6.265625 L 5.855469 7.550781 C 6.109375 7.804688 6.25 8.144531 6.25 8.5 C 6.25 8.855469 6.109375 9.195312 5.855469 9.445312 C 5.605469 9.695312 5.265625 9.835938 4.910156 9.835938 C 4.554688 9.835938 4.214844 9.695312 3.964844 9.445312 L 0.390625 5.875 C 0.140625 5.621094 0 5.28125 0 4.925781 C 0 4.574219 0.140625 4.230469 0.390625 3.980469 L 3.964844 0.410156 C 4.085938 0.277344 4.234375 0.171875 4.398438 0.0976562 C 4.5625 0.0273438 4.742188 -0.0117188 4.921875 -0.015625 C 5.101562 -0.0195312 5.277344 0.0117188 5.445312 0.0820312 C 5.613281 0.148438 5.761719 0.25 5.890625 0.375 C 6.019531 0.503906 6.117188 0.652344 6.1875 0.820312 C 6.253906 0.988281 6.285156 1.167969 6.28125 1.347656 C 6.28125 1.527344 6.242188 1.703125 6.167969 1.867188 C 6.09375 2.03125 5.988281 2.179688 5.855469 2.300781 L 4.570312 3.589844 L 14.285156 3.589844 C 17.128906 3.589844 19.851562 4.71875 21.863281 6.726562 C 23.871094 8.734375 25 11.460938 25 14.300781 Z M 25 14.300781 "
            })
        })
    });
};
/* harmony default export */ var GenericLayout_BackButtonSVG = (BackButtonSVG);

// EXTERNAL MODULE: ./helpers/debounce.ts
var debounce = __webpack_require__(4702);
// EXTERNAL MODULE: ./helpers/closeAllNavMenus.ts
var closeAllNavMenus = __webpack_require__(7371);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(3090);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6580);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(3946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(8462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js + 1 modules
var ListItemButton = __webpack_require__(6113);
;// CONCATENATED MODULE: ./components/GenericLayout/BoothInfoComponent.tsx









function BootstrapDialogTitle(props) {
    const { children , onClose , ...other } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        sx: {
            m: 0,
            p: 2
        },
        ...other,
        children: [
            children,
            onClose ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                onClick: onClose,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            }) : null
        ]
    });
}
const InfoButton = (param)=>{
    let { handleInfoClick , isMobile  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        variant: isMobile ? "controlPanel" : "controlPanelDesktop",
        onClick: ()=>handleInfoClick(undefined),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "32",
                    height: "32",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16 27.9999V13.3333",
                            stroke: "white",
                            strokeWidth: "3",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.0508 4H16",
                            stroke: "white",
                            strokeWidth: "3.58",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    color: "#ffffff",
                    fontSize: "0.7rem"
                },
                children: "Booth Info"
            })
        ]
    });
};
function BoothInfoComponent(param) {
    let { isInfoOpen , handleInfoClick , isMobile =false  } = param;
    const handleClose = ()=>{
        handleInfoClick(undefined);
    };
    const handleClick = (clickedCategory)=>{
        handleInfoClick(clickedCategory);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, {
                handleInfoClick: handleInfoClick,
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BootstrapDialog, {
                fullWidth: true,
                onClose: handleClose,
                open: isInfoOpen,
                hideBackdrop: isMobile ? false : true,
                sx: {
                    ".MuiDialog-container": {
                        justifyContent: isMobile ? "center" : "end",
                        alignItems: isMobile ? "center" : "end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BootstrapDialogTitle, {
                        onClose: handleClose,
                        children: "Visit Booth:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                        dividers: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                    onClick: ()=>handleClick("brochures"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        fontWeight: "bold",
                                        children: "BROCHURES"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                    onClick: ()=>handleClick("tv"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        fontWeight: "bold",
                                        children: "VIDEOS"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                    onClick: ()=>handleClick("contact"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        fontWeight: "bold",
                                        children: "CONTACT"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/NavigationMenu/FooterSection.tsx
















const FooterSection = (param)=>{
    let { isDeviceOnLandscape =false  } = param;
    const { setActiveCategory , boothID , setBoothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const { setIsSideNavOpen , setIsMenuExpanded , setIsBurgerOpen , setIsInfoCategoryClicked , hallZoomValue , setHallZoomValue , isBoothVisitPartActive , setIsSingleBoothViewButtonPressed , setIsVideoClicked , setIsBoothContactFormOpen , areControlPanelButtonsDisabled , setIsZoomSelected , setIsVideoCategoryClicked  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const [isInfoOpen, setIsInfoOpen] = (0,react.useState)(false);
    const handleOpenMapClick = ()=>{
        setIsSideNavOpen(true);
        setIsMenuExpanded(true);
        setActiveCategory(NAVIGATION_PAGES/* EXHIBITORS_MAP */.y8);
        setIsBurgerOpen(true);
    };
    const handleBackButtonClick = ()=>{
        setIsVideoCategoryClicked(false);
        setIsVideoClicked(false);
        setIsInfoOpen(false);
        if (isBoothVisitPartActive) {
            setIsSingleBoothViewButtonPressed(true);
            return;
        }
        (0,updateBoothURL/* replaceBoothURL */.Cl)();
        setHallZoomValue(0);
        setBoothID("");
        setIsVideoClicked(false);
    };
    const handleInfoClick = function() {
        let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        setIsInfoOpen(!isInfoOpen);
        (0,closeAllNavMenus/* closeAllNavMenus */.A)();
        if (category === "contact") {
            setIsBoothContactFormOpen(true);
            return;
        }
        if (category === "brochures") {
            setIsVideoCategoryClicked(false);
        }
        if (category === undefined) {
            setIsInfoCategoryClicked("");
            return;
        }
        setIsInfoCategoryClicked(category);
    };
    const handleZoomChange = (e)=>{
        setHallZoomValue(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationCustomComponents/* FooterWrapper */.V6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SimpleBox */.js, {
                sx: {
                    display: "flex",
                    gap: "1rem"
                },
                children: [
                    boothID !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "controlPanel",
                        onClick: (0,debounce/* debounce */.D)(handleBackButtonClick),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericLayout_BackButtonSVG, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "controlPanel",
                        onClick: ()=>handleOpenMapClick(),
                        sx: {
                            display: !boothID ? "flex" : "none",
                            width: isDeviceOnLandscape ? "20px" : null,
                            height: isDeviceOnLandscape ? "40px" : null
                        },
                        disabled: areControlPanelButtonsDisabled ? true : false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericLayout_MapIconSVG, {})
                    }),
                    !boothID && !areControlPanelButtonsDisabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SimpleBox */.js, {
                        sx: {
                            pointerEvents: "auto",
                            backgroundColor: "rgba(0, 0, 0)",
                            width: "10rem",
                            padding: "0rem 1rem",
                            height: isDeviceOnLandscape ? "40px" : "64px",
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                            opacity: 0.4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/zoom.png",
                                alt: "map icon",
                                width: 30,
                                height: 30,
                                style: {
                                    pointerEvents: "auto"
                                },
                                onClick: ()=>handleOpenMapClick()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                                defaultValue: 0,
                                "aria-label": "Default",
                                valueLabelDisplay: "auto",
                                value: hallZoomValue,
                                marks: [
                                    {
                                        value: 0
                                    },
                                    {
                                        value: 25
                                    },
                                    {
                                        value: 50
                                    },
                                    {
                                        value: 75
                                    },
                                    {
                                        value: 100
                                    }
                                ],
                                step: 25,
                                onChange: (e)=>handleZoomChange(e),
                                onTouchStart: ()=>setIsZoomSelected(true),
                                onTouchEnd: ()=>setIsZoomSelected(false)
                            })
                        ]
                    })
                ]
            }),
            boothID !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoothInfoComponent, {
                isInfoOpen: isInfoOpen,
                handleInfoClick: handleInfoClick,
                isMobile: true
            })
        ]
    });
};
FooterSection.r3f = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(fiber_components_SingleBoothViewFiberComponent, {});
};
/* harmony default export */ var NavigationMenu_FooterSection = (FooterSection);

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(1903);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(1425);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(8951);
// EXTERNAL MODULE: ./components/GenericLayout/ErrorBox.tsx
var ErrorBox = __webpack_require__(9497);
// EXTERNAL MODULE: ./components/GenericLayout/SuccessBox.tsx
var SuccessBox = __webpack_require__(4508);
// EXTERNAL MODULE: ./configs/ROOMS_DATA.ts
var ROOMS_DATA = __webpack_require__(1522);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(6143);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 5 modules
var i18next = __webpack_require__(4853);
// EXTERNAL MODULE: ./components/MaterialCustomComponents/NewsletterComponents.ts
var NewsletterComponents = __webpack_require__(1701);
;// CONCATENATED MODULE: ./components/Contact-form/BoothContactForm.tsx
/* provided dependency */ var process = __webpack_require__(3454);
















const initialFormData = {
    fullName: "",
    email: "",
    phone: "",
    text: ""
};
const BoothContactForm = (param)=>{
    let { boothID  } = param;
    var _boothID_split, _ROOMS_DATA_hall;
    const hall = (_boothID_split = boothID === null || boothID === void 0 ? void 0 : boothID.split("-")) === null || _boothID_split === void 0 ? void 0 : _boothID_split[0];
    const Exhibitor = ROOMS_DATA/* ROOMS_DATA */.O === null || ROOMS_DATA/* ROOMS_DATA */.O === void 0 ? void 0 : (_ROOMS_DATA_hall = ROOMS_DATA/* ROOMS_DATA */.O[hall]) === null || _ROOMS_DATA_hall === void 0 ? void 0 : _ROOMS_DATA_hall.filter((stand)=>stand.name === boothID)[0];
    const { isBoothContactFormOpen , setIsBoothContactFormOpen  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const [formData, setFormData] = (0,react.useState)(initialFormData);
    const [fetching, setFetching] = (0,react.useState)(false);
    const [complete, setComplete] = (0,react.useState)(false);
    const [captchaValidated, setCaptchaValidated] = (0,react.useState)(false);
    const [errorMsg, setErrorMsg] = (0,react.useState)("");
    const onInputData = (prop, value)=>{
        setFormData({
            ...formData,
            [prop]: value
        });
    };
    const initializeStates = ()=>{
        setFetching(false);
        setCaptchaValidated(false);
    };
    (0,react.useEffect)(()=>{
        initializeStates();
        setErrorMsg("");
        setComplete(false);
        return initializeStates;
    }, []);
    const sendEmail = async (e)=>{
        e.preventDefault();
        setFetching(true);
        setComplete(false);
        setErrorMsg("");
        const contacts = Exhibitor.data.email;
        // this is where your mailchimp request is made
        const res = await fetch("/api/sendEmail", {
            body: JSON.stringify({
                ...formData,
                contacts: process.env.NEXT_PUBLIC_EMAIL_CONTACTS ? process.env.NEXT_PUBLIC_EMAIL_CONTACTS : contacts
            }),
            headers: {
                "Content-Type": "application/json"
            },
            method: "POST"
        });
        setFetching(false);
        try {
            const resHasError = (await res.json()).error;
            if (resHasError) {
                return setErrorMsg(resHasError);
            }
            setFormData(initialFormData);
            return setComplete(true);
        } catch (e1) {
            console.error(e1);
        }
    };
    function onChange(value) {
        setCaptchaValidated(!!value);
    }
    const cancelForm = ()=>{
        setIsBoothContactFormOpen(false);
        setFormData(initialFormData);
        initializeStates();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
        sx: {
            pointerEvents: "auto",
            position: "absolute"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
            open: isBoothContactFormOpen,
            onClose: ()=>{
                setIsBoothContactFormOpen(false);
                initializeStates();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: sendEmail,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                        children: (0,i18next.t)("contactForm.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                                children: (0,i18next.t)("contactForm.subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                required: true,
                                autoFocus: true,
                                margin: "dense",
                                id: "name",
                                label: "Full Name",
                                type: "text",
                                fullWidth: true,
                                variant: "standard",
                                onInput: (e)=>onInputData("fullName", e.target.value),
                                value: formData.fullName,
                                sx: {
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "black"
                                    },
                                    "& .MuiInputBase-root.MuiInput-underline:after": {
                                        border: "none"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                required: true,
                                autoFocus: true,
                                margin: "dense",
                                id: "email",
                                value: formData.email,
                                onInput: (e)=>onInputData("email", e.target.value),
                                label: "Email Address",
                                type: "email",
                                fullWidth: true,
                                variant: "standard",
                                sx: {
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "black"
                                    },
                                    "& .MuiInputBase-root.MuiInput-underline:after": {
                                        border: "none"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                autoFocus: true,
                                margin: "dense",
                                id: "phone",
                                onInput: (e)=>onInputData("phone", e.target.value),
                                value: formData.phone,
                                label: "Phone Number",
                                type: "number",
                                fullWidth: true,
                                variant: "standard",
                                sx: {
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "black"
                                    },
                                    "& .MuiInputBase-root.MuiInput-underline:after": {
                                        border: "none"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                required: true,
                                autoFocus: true,
                                margin: "dense",
                                id: "message",
                                label: "Message",
                                onInput: (e)=>onInputData("text", e.target.value),
                                value: formData.text,
                                type: "text",
                                fullWidth: true,
                                multiline: true,
                                rows: 4,
                                variant: "standard",
                                sx: {
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "black"
                                    },
                                    "& .MuiInputBase-root.MuiInput-underline:after": {
                                        border: "none"
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                            sitekey: "6Lf9V-gjAAAAAFS9sJuyG6hn5jg0Z21FnuNL7Ojn" || 0,
                            onChange: onChange,
                            size: "normal"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterComponents/* ConfirmButton */.p, {
                                variant: "primary",
                                onClick: cancelForm,
                                children: (0,i18next.t)("contactForm.close")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterComponents/* ConfirmButton */.p, {
                                variant: "primary",
                                type: "submit",
                                disabled: fetching || !captchaValidated,
                                children: (0,i18next.t)("contactForm.send")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            errorMsg.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBox/* ErrorBox */.T, {
                                msg: (0,i18next.t)("contactForm.error_message")
                            }),
                            complete && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessBox/* SuccessBox */._, {
                                msg: (0,i18next.t)("contactForm.success_message")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Contact_form_BoothContactForm = (BoothContactForm);

// EXTERNAL MODULE: ./helpers/getOffersData.ts
var getOffersData = __webpack_require__(9893);
;// CONCATENATED MODULE: ./components/BoothOfferBanner.tsx








const BoothOfferBanner = (param)=>{
    let { isOpen =false  } = param;
    const { setIsOffersBoxClicked  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { boothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const [offerBanner, setOfferBanner] = (0,react.useState)("/bg-placeholder.png");
    (0,react.useEffect)(()=>{
        if (boothID === "") return;
        (0,getOffersData/* default */.Z)().then((res)=>{
            res.forEach((offer)=>{
                if (boothID === offer.standDescription && offer.banner) {
                    setOfferBanner(offer.banner);
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boothID
    ]);
    const handleClose = ()=>{
        setIsOffersBoxClicked(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        onClose: handleClose,
        open: isOpen,
        onChange: handleClose,
        fullWidth: true,
        maxWidth: "xl",
        PaperProps: {
            style: {
                height: "100vh"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: "Offer Banner"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                sx: {
                    position: "absolute",
                    right: "10px",
                    top: "20px",
                    cursor: "pointer",
                    zIndex: 1000000
                },
                onClick: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: offerBanner,
                fill: true,
                style: {
                    objectFit: "contain"
                },
                alt: "offer banner"
            })
        ]
    });
};
/* harmony default export */ var components_BoothOfferBanner = (BoothOfferBanner);

// EXTERNAL MODULE: ./hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(8246);
;// CONCATENATED MODULE: ./components/GenericLayout/ControlPanelDesktop.tsx






















const ControlPanelDesktop = ()=>{
    const { setIsSingleBoothViewButtonPressed , setIsInfoCategoryClicked , setHallZoomValue , isBoothVisitPartActive , setIsVideoClicked , setIsSideNavOpen , setIsMenuExpanded , setIsBurgerOpen , hallZoomValue , isExpoPageLoaded , setIsCameraZoomEnabled , setIsBoothContactFormOpen , setIsVideoCategoryClicked  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { setArrowDirection , newTrigger , hallID , boothID , setActiveCategory  } = (0,useRouterStore/* useRouterStore */.U)();
    const { booths  } = (0,useModelStore/* useModelStore */.V)();
    const { height  } = (0,useWindowSize/* useWindowSize */.i)();
    const [isControlPanelDisabled, setIsControlPanelDisabled] = (0,react.useState)(false);
    const [isInfoOpen, setIsInfoOpen] = (0,react.useState)(false);
    const { query  } = (0,router.useRouter)();
    (0,react.useEffect)(()=>{
        if (isExpoPageLoaded) {} else {
            setIsCameraZoomEnabled(false);
        }
        setIsControlPanelDisabled(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isExpoPageLoaded
    ]);
    const handleChangeButtons = (direction)=>{
        setIsControlPanelDisabled(true);
        setIsCameraZoomEnabled(true);
        setHallZoomValue(0);
        setIsVideoClicked(false);
        setIsInfoCategoryClicked("");
        setArrowDirection(direction);
        newTrigger();
    };
    const handleOpenMapClick = ()=>{
        setIsSideNavOpen(true);
        setIsMenuExpanded(true);
        setActiveCategory(NAVIGATION_PAGES/* EXHIBITORS_MAP */.y8);
        setIsBurgerOpen(true);
    };
    const handleBackButtonClick = ()=>{
        setIsVideoCategoryClicked(false);
        setIsVideoClicked(false);
        setIsInfoOpen(false);
        if (isBoothVisitPartActive) {
            setIsSingleBoothViewButtonPressed(true);
            return;
        }
        (0,updateBoothURL/* updateRoute */.fq)("/expo/halls/".concat(query["hall-ID"], "/booths"));
        setHallZoomValue(0);
        setIsVideoClicked(false);
    };
    const handleInfoClick = function() {
        let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        (0,closeAllNavMenus/* closeAllNavMenus */.A)();
        if (category === "contact") {
            setIsBoothContactFormOpen(true);
            return;
        }
        if (category === "brochures") {
            setIsVideoCategoryClicked(false);
        }
        if (category === undefined) {
            setIsInfoCategoryClicked("");
            setIsInfoOpen(!isInfoOpen);
            return;
        }
        setIsInfoCategoryClicked(category);
    };
    const handleZoomChange = (e)=>{
        setHallZoomValue(e.target.value);
    };
    const splitBoothID = (booth, direction)=>{
        if (boothID === "") {
            return true;
        }
        if (direction === "left") {
            const hasBoothToTheLeft = findBoothIndex(booth, booths, "left");
            return hasBoothToTheLeft ? true : false;
        }
        if (direction === "right") {
            const hasBoothToTheRight = findBoothIndex(booth, booths, "right");
            return hasBoothToTheRight ? true : false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
        sx: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height:  true && height,
            pointerEvents: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
            paddingBottom: "1rem"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SimpleBox */.js, {
            sx: {
                backgroundColor: "black",
                border: "3px solid white",
                padding: "0.5rem",
                display: "flex",
                gap: "1rem"
            },
            children: [
                !isBoothVisitPartActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "controlPanelDesktop",
                    onClick: ()=>handleChangeButtons(ARROWS_DIRECTION_CONFIG/* LEFT */.R),
                    disabled: isControlPanelDisabled || (splitBoothID(boothID, "left") ? false : true) || (Number(hallID) === 1 && boothID === "" ? true : false),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowIcon/* default */.Z, {
                                width: 20,
                                height: 20,
                                strokeWidth: 3
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#ffffff",
                                fontSize: "0.7rem"
                            },
                            children: boothID === "" ? "Previous Hall" : "Previous Booth"
                        })
                    ]
                }),
                boothID !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "controlPanelDesktop",
                    onClick: (0,debounce/* debounce */.D)(handleBackButtonClick),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericLayout_BackButtonSVG, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#ffffff",
                                fontSize: "0.7rem"
                            },
                            children: "Go Back"
                        })
                    ]
                }),
                boothID !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoothInfoComponent, {
                        isInfoOpen: isInfoOpen,
                        handleInfoClick: handleInfoClick
                    })
                }),
                boothID === "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            variant: "controlPanelDesktop",
                            onClick: ()=>handleOpenMapClick(),
                            disabled: isControlPanelDisabled ? true : false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericLayout_MapIconSVG, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#ffffff",
                                        fontSize: "0.7rem"
                                    },
                                    children: "Booths Map"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SimpleBox */.js, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SimpleBox */.js, {
                                    sx: {
                                        pointerEvents: "auto",
                                        backgroundColor: "rgba(0, 0, 0)",
                                        width: "10rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "1rem",
                                        opacity: isControlPanelDisabled ? 0.5 : 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/zoom.png",
                                            alt: "map icon",
                                            width: 30,
                                            height: 30,
                                            style: {
                                                pointerEvents: "auto"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                                            disabled: isControlPanelDisabled ? true : false,
                                            defaultValue: 0,
                                            "aria-label": "Default",
                                            valueLabelDisplay: "auto",
                                            value: isControlPanelDisabled ? 0 : hallZoomValue,
                                            marks: [
                                                {
                                                    value: 0
                                                },
                                                {
                                                    value: 25
                                                },
                                                {
                                                    value: 50
                                                },
                                                {
                                                    value: 75
                                                },
                                                {
                                                    value: 100
                                                }
                                            ],
                                            step: 25,
                                            onChange: (e)=>handleZoomChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#ffffff",
                                        fontSize: "0.8rem",
                                        opacity: isControlPanelDisabled ? 0.5 : 1
                                    },
                                    children: "Hall Zoom"
                                })
                            ]
                        })
                    ]
                }),
                !isBoothVisitPartActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "controlPanelDesktop",
                    onClick: Number(hallID) === 6 && boothID === "" ? ()=>{
                        (0,animateStripes/* openStripes */.J)(()=>{
                            (0,updateBoothURL/* updateRoute */.fq)("/conference_hall");
                        });
                    } : ()=>handleChangeButtons(ARROWS_DIRECTION_CONFIG/* RIGHT */.p),
                    disabled: isControlPanelDisabled || (splitBoothID(boothID, "right") ? false : true),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon/* default */.Z, {
                                width: 20,
                                height: 20,
                                strokeWidth: 3
                            })
                        }),
                        boothID === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#ffffff",
                                fontSize: "0.7rem"
                            },
                            children: Number(hallID) === 6 && boothID === "" ? "Conference Hall" : "Next Hall"
                        }),
                        boothID !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#ffffff",
                                fontSize: "0.7rem"
                            },
                            children: "Next Booth"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GenericLayout_ControlPanelDesktop = (ControlPanelDesktop);

;// CONCATENATED MODULE: ./hooks/useScreenOrientation.ts

const useScreenOrientation = ()=>{
    const [phoneOrientation, setPhoneOrientation] = (0,react.useState)({
        portrait: true,
        landscape: false
    });
    (0,react.useEffect)(()=>{
        var _screen_orientation, _screen_orientation_type, _screen_orientation1, _screen_orientation2, _screen_orientation_addEventListener;
        const initialScreenOrientation = screen === null || screen === void 0 ? void 0 : (_screen_orientation = screen.orientation) === null || _screen_orientation === void 0 ? void 0 : (_screen_orientation_type = _screen_orientation.type) === null || _screen_orientation_type === void 0 ? void 0 : _screen_orientation_type.split("-")[0];
        function changeOrientation(e) {
            var _e_target, _e_target_type, _screen_orientation;
            const splitTargetType = e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_type = _e_target.type) === null || _e_target_type === void 0 ? void 0 : _e_target_type.split("-")[0];
            if (splitTargetType === "portrait") {
                setPhoneOrientation({
                    portrait: true,
                    landscape: false
                });
                return;
            }
            if (splitTargetType === "landscape" && (screen === null || screen === void 0 ? void 0 : (_screen_orientation = screen.orientation) === null || _screen_orientation === void 0 ? void 0 : _screen_orientation.angle) > 0) {
                setPhoneOrientation({
                    portrait: false,
                    landscape: true
                });
            } else {
                setPhoneOrientation({
                    portrait: true,
                    landscape: false
                });
            }
            return;
        }
        if (initialScreenOrientation === "portrait") {
            setPhoneOrientation({
                portrait: true,
                landscape: false
            });
        }
        if (initialScreenOrientation === "landscape" && (screen === null || screen === void 0 ? void 0 : (_screen_orientation1 = screen.orientation) === null || _screen_orientation1 === void 0 ? void 0 : _screen_orientation1.angle) > 0) {
            setPhoneOrientation({
                portrait: false,
                landscape: true
            });
        }
        screen === null || screen === void 0 ? void 0 : (_screen_orientation2 = screen.orientation) === null || _screen_orientation2 === void 0 ? void 0 : (_screen_orientation_addEventListener = _screen_orientation2.addEventListener) === null || _screen_orientation_addEventListener === void 0 ? void 0 : _screen_orientation_addEventListener.call(_screen_orientation2, "change", changeOrientation);
        return ()=>{
            var _window_removeEventListener;
            return window === null || window === void 0 ? void 0 : (_window_removeEventListener = window.removeEventListener) === null || _window_removeEventListener === void 0 ? void 0 : _window_removeEventListener.call(window, "change", changeOrientation);
        };
    }, []);
    return phoneOrientation;
};

// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(4054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(3841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 11 modules
var Select = __webpack_require__(1683);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 4 modules
var MenuItem = __webpack_require__(5819);
;// CONCATENATED MODULE: ./components/fiber-components/SafariVideoComponent.tsx









const SafariVideoComponent = ()=>{
    const { isSafariBrowser , isVideoClicked , setIsVideoClicked , setIsSingleBoothViewButtonPressed  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { booths  } = (0,useModelStore/* useModelStore */.V)();
    const { boothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const [selectedVideo, setSelectedVideo] = (0,react.useState)("BUILDING SOLUTIONS (LIST)");
    const [videoURL, setVideoURL] = (0,react.useState)("");
    const [videos, setVideos] = (0,react.useState)([]);
    const [open, setOpen] = (0,react.useState)(false);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    (0,react.useEffect)(()=>{
        if (isSafariBrowser && isVideoClicked) {
            setOpen(true);
            setIsSingleBoothViewButtonPressed(false);
        }
        getBoothVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boothID,
        isSafariBrowser,
        isVideoClicked
    ]);
    const getBoothVideos = ()=>{
        booths === null || booths === void 0 ? void 0 : booths.forEach((booth)=>{
            if (booth.name === boothID) {
                setVideos(booth.data.video);
                setVideoURL(booth.data.video[0].url);
                setSelectedVideo(booth.data.video[0].title);
            }
        });
    };
    const handleChange = (e)=>{
        setSelectedVideo(e.target.value);
    };
    const changeVideoURL = (url)=>{
        if (!url) return;
        setVideoURL(url);
    };
    const handleClose = ()=>{
        setOpen(false);
        setIsVideoClicked(false);
        setIsSingleBoothViewButtonPressed(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaterialCustomComponents/* SafariDialog */.FH, {
        maxWidth: "xl",
        onClose: handleClose,
        open: open,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                sx: {
                    fontSize: "1rem"
                },
                children: "BUILDING SOLUTIONS (LIST)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                sx: {
                    position: "absolute",
                    right: "10px",
                    top: "20px",
                    cursor: "pointer"
                },
                onClick: handleClose
            }),
            width >= 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: videoURL,
                controls: true,
                autoPlay: true,
                width: 900,
                height: 500
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        src: videoURL,
                        controls: true,
                        autoPlay: true,
                        style: {
                            width: "100%",
                            height: "100%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                        sx: {
                            width: width
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                sx: {
                    marginTop: "2rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                        id: "demo-simple-select-label",
                        children: "BUILDING SOLUTIONS (LIST)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        labelId: "demo-simple-select-label",
                        id: "demo-simple-select",
                        value: selectedVideo,
                        label: "BUILDING SOLUTIONS (LIST)",
                        onChange: handleChange,
                        children: videos === null || videos === void 0 ? void 0 : videos.map((param)=>/*#__PURE__*/ {
                            let { title , url  } = param;
                            return (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: title,
                                onClick: ()=>changeVideoURL(url),
                                children: title
                            }, title);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fiber_components_SafariVideoComponent = (SafariVideoComponent);

// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(1458);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(4776);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(6798);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(1737);
;// CONCATENATED MODULE: ./components/Mobile-indicators/Styled-Components/MobileIndicatorsStyled.ts

const MobileIndicatorsSnackbar = (0,styled/* default */.ZP)(Snackbar/* default */.Z)((param)=>{
    let {} = param;
    return {
        zIndex: 11,
        minHeight: "100px",
        "&.MuiSnackbar-root": {
            position: "absolute",
            width: "65%",
            left: 0,
            maxWidth: "320px"
        },
        "& .MuiPaper-root": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
});
const MobileIndicatorsAlert = (0,styled/* default */.ZP)(Alert/* default */.Z)((param)=>{
    let {} = param;
    return {
        height: "100%",
        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
        backgroundColor: "black",
        color: "#ffffff",
        "& .MuiAlert-action": {
            padding: "0px"
        }
    };
});
const RotatePhoneAnimationWrapper = (0,styled/* default */.ZP)(Box/* default */.Z)(()=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }));
const SwipeHandAnimationWrapper = (0,styled/* default */.ZP)(Box/* default */.Z)(()=>({
        position: "absolute",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 11,
        pointerEvents: "none"
    }));
const UserSwipeOverlay = (0,styled/* default */.ZP)(Box/* default */.Z)(()=>({
        width: "100%",
        height: "100vh",
        backgroundColor: "transparent",
        position: "absolute",
        touchAction: "none"
    }));

;// CONCATENATED MODULE: ./components/Mobile-indicators/MobileIndicators.tsx







const SlideAnimation = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
        ...props,
        direction: "right"
    });
};
const MobileIndicators = ()=>{
    const { isExpoPageLoaded , hasUserSwiped  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { portrait  } = useScreenOrientation();
    const [isMobileDevice, setIsMobileDevice] = (0,react.useState)(null);
    const [open, setOpen] = (0,react.useState)(false);
    const [isFirstRender, setIsFirstRender] = (0,react.useState)(true);
    const handleClose = ()=>{
        setOpen(false);
    };
    (0,react.useEffect)(()=>{
        const isMobileOrTablet = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Tablet|Kindle/i.test(navigator.userAgent);
        isMobileOrTablet ? setIsMobileDevice(true) : setIsMobileDevice(false);
    }, [
        portrait
    ]);
    (0,react.useEffect)(()=>{
        if (isMobileDevice && isExpoPageLoaded && isFirstRender) {
            setTimeout(()=>{
                setOpen(true);
            }, 3000);
            setTimeout(()=>{
                handleClose();
            }, 8000);
            setIsFirstRender(false);
        }
    }, [
        isExpoPageLoaded,
        isFirstRender,
        isMobileDevice
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIndicatorsSnackbar, {
                open: portrait ? open : false,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                TransitionComponent: SlideAnimation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIndicatorsAlert, {
                    onClose: handleClose,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatePhoneAnimationWrapper, {
                        className: "rotate-phone-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/rotate-mobile.svg",
                            width: 48,
                            height: 48,
                            alt: "rotate phone icon"
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontWeight: "bold",
                        textAlign: "center",
                        px: 1,
                        children: "For better experience!"
                    })
                })
            }),
            !hasUserSwiped && isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeHandAnimationWrapper, {
                    className: "swipe-screen-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/swipe-icon.svg",
                        width: 64,
                        height: 64,
                        alt: "swipe icon"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Mobile_indicators_MobileIndicators = (MobileIndicators);

;// CONCATENATED MODULE: ./components/ControlPanel.tsx























const ControlPanel = ()=>{
    const { isOffersBoxClicked  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { boothID  } = (0,useRouterStore/* useRouterStore */.U)();
    const controlPanelRef = (0,react.useRef)();
    const { width , height  } = (0,useWindowSize/* useWindowSize */.i)();
    const { landscape  } = useScreenOrientation();
    const { isMobileBrowser  } = useMobileBrowser();
    const calculateHeight = ()=>{
        if (false) {}
        controlPanelRef.current.style.height = "".concat(window.innerHeight, "px");
    };
    (0,react.useEffect)(()=>{
        if (!height) return;
        calculateHeight();
    }, [
        height
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ControlPanelWrapper, {
        ref: controlPanelRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* BlackBgBanner */.r4, {
                className: "black-bg-banner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                    variant: "indeterminate",
                    color: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact_form_BoothContactForm, {
                boothID: boothID
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_indicators_MobileIndicators, {}),
            isOffersBoxClicked && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoothOfferBanner, {
                isOpen: isOffersBoxClicked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialCustomComponents/* SimpleBox */.js, {
                sx: {
                    opacity: !boothID ? 1 : 0
                },
                children: landscape || width >= 600 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/logo.svg",
                    alt: "ktirio logo",
                    width: landscape ? 80 : 160,
                    height: landscape ? 40 : 85,
                    onClick: ()=>(0,animateStripes/* openStripes */.J)(()=>(0,updateBoothURL/* updateRoute */.fq)("/")),
                    style: {
                        pointerEvents: "auto",
                        cursor: "pointer"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/logo.svg",
                    alt: "ktirio logo",
                    width: 120,
                    height: 65,
                    onClick: ()=>(0,animateStripes/* openStripes */.J)(()=>(0,updateBoothURL/* updateRoute */.fq)("/")),
                    style: {
                        pointerEvents: "auto",
                        cursor: "pointer"
                    }
                })
            }),
            isMobileBrowser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationMenu_ArrowNavigation, {
                        isDeviceOnLandscape: landscape
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationMenu_FooterSection, {
                        isDeviceOnLandscape: landscape
                    })
                ]
            }),
            !isMobileBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericLayout_ControlPanelDesktop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fiber_components_SafariVideoComponent, {})
        ]
    });
};
ControlPanel.r3f = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fiber_components_ChangeBoothFiberComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fiber_components_ChangeHallFiberComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fiber_components_ChangeCameraFiberComponent, {})
        ]
    });
};
/* harmony default export */ var components_ControlPanel = (ControlPanel);

// EXTERNAL MODULE: ./helpers/initializeScene.ts + 5 modules
var initializeScene = __webpack_require__(9368);
// EXTERNAL MODULE: ./components/Exhibitors-map/ExhibitorsMap.tsx + 10 modules
var ExhibitorsMap = __webpack_require__(2788);
;// CONCATENATED MODULE: ./helpers/detectSafari.ts
function detectSafari(keyword) {
    return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

;// CONCATENATED MODULE: ./components/fiber-components/Scene.tsx










const Scene = (param)=>{
    let { children  } = param;
    const { setIsSafariBrowser , setIsSideNavOpen  } = (0,useComponentLoadingStateStore/* useComponentLoadingStateStore */.C)();
    const { fov , position  } = CAMERA_CONFIG/* CAMERA_CONFIG */.Uf;
    (0,react.useEffect)(()=>{
        (0,initializeScene/* initializeStripesFirstRender */.y)();
        const isSafari = (!!window.ApplePaySetupFeature || !!window.safari) && detectSafari("Safari") && !detectSafari("Chrome") && !detectSafari("CriOS");
        if (isSafari) {
            setIsSafariBrowser(true);
            return;
        }
        setIsSafariBrowser(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: "100vw",
            height: "100vh",
            position: "absolute",
            top: 0,
            left: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ControlPanel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_three_fiber_esm/* Canvas */.Xz, {
                camera: {
                    fov: fov,
                    position: [
                        position[0],
                        position[1],
                        position[2]
                    ],
                    rotation: [
                        -0.3,
                        0,
                        0
                    ]
                },
                dpr: [
                    2,
                    2
                ],
                onMouseDown: ()=>setIsSideNavOpen(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        components_ControlPanel.r3f(),
                        ExhibitorsMap/* default.r3f */.Z.r3f(),
                        NavigationMenu_FooterSection.r3f(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ambientLight", {
                            intensity: 0.5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("directionalLight", {
                            position: [
                                0,
                                20,
                                20
                            ],
                            intensity: 1
                        }),
                        children
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var fiber_components_Scene = (Scene);


/***/ }),

/***/ 7405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uf": function() { return /* binding */ CAMERA_CONFIG; },
/* harmony export */   "dH": function() { return /* binding */ CAMERA_ROTATION_POSITION_OFFSETS; },
/* harmony export */   "lW": function() { return /* binding */ CAMERA_OFFSETS; }
/* harmony export */ });
const CAMERA_CONFIG = {
    fov: 45,
    position: [
        0,
        33,
        101
    ]
};
const CAMERA_OFFSETS = {
    x: -1,
    y: 4,
    z: 18
};
const CAMERA_ROTATION_POSITION_OFFSETS = {
    middle: {
        position: {
            x: 4,
            y: 0,
            z: 0
        },
        rotation: {
            x: 0,
            y: 0,
            z: 0
        }
    },
    left: {
        position: {
            x: 4,
            y: 0,
            z: 0
        },
        rotation: {
            x: 0,
            y: 0.34,
            z: 0
        }
    },
    right: {
        position: {
            x: 4,
            y: 0,
            z: 0
        },
        rotation: {
            x: 0,
            y: -0.34,
            z: 0
        }
    }
};


/***/ }),

/***/ 4702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
const debounce = function(fn) {
    let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    let timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(()=>fn(...args), delay);
    };
};


/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ blurHorizontalBannerImage; },
/* harmony export */   "Px": function() { return /* binding */ handleBoothUnhover; },
/* harmony export */   "TC": function() { return /* binding */ handleBoothHover; },
/* harmony export */   "uF": function() { return /* binding */ BOOTH_UNHIGHLIGHT_COLOR; },
/* harmony export */   "yR": function() { return /* binding */ BOOTH_HIGHLIGHT_COLOR; }
/* harmony export */ });
/* harmony import */ var _store_useRouterStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4049);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9477);
/* harmony import */ var _store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8831);



const BOOTH_HIGHLIGHT_COLOR = new three__WEBPACK_IMPORTED_MODULE_2__.Color("#94b0f7").convertSRGBToLinear();
const BOOTH_UNHIGHLIGHT_COLOR = new three__WEBPACK_IMPORTED_MODULE_2__.Color("#ffffff");
const handleBoothHover = (e, boothObject)=>{
    e.stopPropagation();
    const boothID = _store_useRouterStore__WEBPACK_IMPORTED_MODULE_0__/* .useRouterStore.getState */ .U.getState().boothID;
    if (boothID !== "" || !boothObject) return;
    document.body.style.cursor = "pointer";
    boothObject.children.forEach((mesh)=>{
        if (!mesh.material) return;
        const newMaterial = mesh.material.clone();
        const meshName = mesh.name.split("-")[0];
        if (meshName === "tv" || meshName === "offer") return;
        mesh.material = newMaterial;
        newMaterial.color = BOOTH_HIGHLIGHT_COLOR;
        newMaterial.needsUpdate = true;
    });
};
const handleBoothUnhover = (e, boothObject)=>{
    if (e !== undefined) {
        e.stopPropagation();
    }
    document.body.style.cursor = "auto";
    const isBoothVisitPartActive = _store_useComponentLoadingStateStore__WEBPACK_IMPORTED_MODULE_1__/* .useComponentLoadingStateStore.getState */ .C.getState().isBoothVisitPartActive;
    if (isBoothVisitPartActive || !boothObject) return;
    boothObject.children.forEach((mesh)=>{
        if (!mesh.material) return;
        const meshName = mesh.name.split("-")[0];
        if (meshName === "tv" || meshName === "offer") return;
        mesh.material.color = BOOTH_UNHIGHLIGHT_COLOR;
        mesh.material.needsUpdate = true;
    });
};
const blurHorizontalBannerImage = (object, blurValue)=>{
    if (!object) return;
    if (blurValue === "blur") {
        object.material.color = new three__WEBPACK_IMPORTED_MODULE_2__.Color("#6b6b6b");
        return;
    }
    if (blurValue === "remove-blur") {
        object.material.color = new three__WEBPACK_IMPORTED_MODULE_2__.Color("#ffffff");
        return;
    }
};


/***/ }),

/***/ 9368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ initializeScene; },
  "y": function() { return /* binding */ initializeStripesFirstRender; }
});

// EXTERNAL MODULE: ./node_modules/firebase/storage/dist/esm/index.esm.js + 1 modules
var index_esm = __webpack_require__(6650);
// EXTERNAL MODULE: ./firebase/connectFirebase.ts + 2 modules
var connectFirebase = __webpack_require__(985);
;// CONCATENATED MODULE: ./helpers/getModelsURL.ts


const getModelsURL = (modelName)=>{
    if (!modelName) return;
    const storage = (0,index_esm/* getStorage */.cF)(connectFirebase/* app */.l);
    return (0,index_esm/* getDownloadURL */.Jt)((0,index_esm/* ref */.iH)(storage, modelName)).catch(console.error);
};
/* harmony default export */ var helpers_getModelsURL = (getModelsURL);

// EXTERNAL MODULE: ./helpers/getBoothsData.ts
var getBoothsData = __webpack_require__(665);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
;// CONCATENATED MODULE: ./configs/BOOTH_POSITIONS.ts
const BOOTH_POSITIONS = [
    // left column
    {
        position: [
            -30.5,
            0,
            45
        ],
        rotation: 3.49066
    },
    {
        position: [
            -37.5,
            0,
            22.5
        ],
        rotation: 3.49066
    },
    {
        position: [
            -37.5,
            0,
            0
        ],
        rotation: 3.49066
    },
    {
        position: [
            -37.5,
            0,
            -22.5
        ],
        rotation: 3.49066
    },
    {
        position: [
            -37.5,
            0,
            -45
        ],
        rotation: 3.49066
    },
    {
        position: [
            -20.5,
            0,
            -60
        ],
        rotation: Math.PI
    },
    // middle column
    {
        position: [
            0,
            0,
            30
        ],
        rotation: Math.PI
    },
    {
        position: [
            0,
            0,
            10
        ],
        rotation: Math.PI
    },
    {
        position: [
            0,
            0,
            -10
        ],
        rotation: Math.PI
    },
    {
        position: [
            0,
            0,
            -30
        ],
        rotation: Math.PI
    },
    {
        position: [
            30,
            0,
            45
        ],
        rotation: -3.49066
    },
    // right column
    {
        position: [
            37.5,
            0,
            22.5
        ],
        rotation: -3.49066
    },
    {
        position: [
            37.5,
            0,
            0
        ],
        rotation: -3.49066
    },
    {
        position: [
            37.5,
            0,
            -22.5
        ],
        rotation: -3.49066
    },
    {
        position: [
            37.5,
            0,
            -45
        ],
        rotation: -3.49066
    },
    {
        position: [
            22,
            0,
            -60
        ],
        rotation: Math.PI
    }
];

;// CONCATENATED MODULE: ./helpers/calculateBoothPositions.ts


const calculateBoothPositions = ()=>{
    const values = BOOTH_POSITIONS;
    const boothsArray = [];
    for(let i = 0; i < values.length; i++){
        const positionX = values[i].position[0];
        const positionY = values[i].position[1];
        const positionZ = values[i].position[2];
        const boothCoordinates = new three_module.Vector3(positionX, positionY, positionZ);
        boothsArray.push(boothCoordinates);
    }
    return boothsArray;
};
/* harmony default export */ var helpers_calculateBoothPositions = (calculateBoothPositions);

// EXTERNAL MODULE: ./configs/ROOMS_DATA.ts
var ROOMS_DATA = __webpack_require__(1522);
;// CONCATENATED MODULE: ./configs/SCENE_DATA.ts
const SCENE_DATA = {
    boothURL: null,
    boothSmallURL: null,
    warehouseURL: null,
    booths: null
};

// EXTERNAL MODULE: ./configs/STRIPES_ANIMATION_CONFIG.ts
var STRIPES_ANIMATION_CONFIG = __webpack_require__(9571);
;// CONCATENATED MODULE: ./helpers/calculateBoothRotations.ts

const calculateBoothRotations = ()=>{
    const values = BOOTH_POSITIONS;
    const boothRotationsArray = values.map((value)=>value.rotation);
    return boothRotationsArray;
};

// EXTERNAL MODULE: ./configs/HALLS_CONFIG.ts
var HALLS_CONFIG = __webpack_require__(8767);
;// CONCATENATED MODULE: ./helpers/initializeScene.ts








const firebaseBoothsDataPromise = (0,getBoothsData/* default */.Z)();
const firestorageBoothModelPromise = helpers_getModelsURL("Large.glb");
const firestorageBoothSmallModelPromise = helpers_getModelsURL("Small.glb");
const firestorageWarehouseModelPromise = helpers_getModelsURL("Final.glb");
const sortBoothsByNameID = (halls)=>{
    const sortedHalls = halls;
    Object.values(HALLS_CONFIG/* HALLS */.YX).forEach(()=>{
        sortedHalls.sort((param, param1)=>{
            let { description: description1  } = param, { description: description2  } = param1;
            if (description1[1] < description2[1]) {
                return -1;
            }
            if (description1[1] > description2[1]) {
                return 1;
            }
        });
        sortedHalls.sort((param, param1)=>{
            let { description: description1  } = param, { description: description2  } = param1;
            const splitBoothFromHall1 = description1.split("/")[1];
            const splitBoothFromHall2 = description2.split("/")[1];
            if (splitBoothFromHall1 < splitBoothFromHall2) {
                return -1;
            }
            if (splitBoothFromHall1 > splitBoothFromHall2) {
                return 1;
            }
        });
    });
    return sortedHalls;
};
const populateRooms = (booths)=>{
    if (booths.length === 0 || booths === undefined || booths === null) return;
    const boothPositions = helpers_calculateBoothPositions();
    if (!boothPositions) return;
    const boothRotations = calculateBoothRotations();
    if (!boothRotations) return;
    const sortedBooths = sortBoothsByNameID(booths);
    for(const singleHall in ROOMS_DATA/* ROOMS_DATA */.O){
        let positionIndex = 0;
        sortedBooths.forEach((param)=>{
            let { description , standName , ...rest } = param;
            const splitDescription = description.split("/");
            const hallID = splitDescription[0];
            if (hallID === singleHall) {
                const boothID = splitDescription[1];
                ROOMS_DATA/* ROOMS_DATA */.O[singleHall].push({
                    id: standName,
                    name: "".concat(hallID, "-").concat(boothID),
                    position: boothPositions[positionIndex],
                    rotation: boothRotations[positionIndex],
                    standName: standName,
                    standSize: positionIndex === 0 || positionIndex === 6 || positionIndex === 10 ? "large" : "small",
                    data: rest
                });
                positionIndex++;
            }
        });
    }
};
const initializeScene = ()=>{
    return Promise.all([
        firebaseBoothsDataPromise,
        firestorageBoothModelPromise,
        firestorageWarehouseModelPromise,
        firestorageBoothSmallModelPromise
    ]).then((res)=>{
        populateRooms(res[0][0].stands);
        SCENE_DATA.boothURL = res[1];
        SCENE_DATA.warehouseURL = res[2];
        SCENE_DATA.boothSmallURL = res[3];
        return SCENE_DATA;
    }).catch((err)=>err);
};
const initializeStripesFirstRender = ()=>{
    const stripe1 = document.querySelector(".stripe-1");
    const stripe2 = document.querySelector(".stripe-2");
    const stripe3 = document.querySelector(".stripe-3");
    const stripe4 = document.querySelector(".stripe-4");
    if (!stripe1 || !stripe2 || !stripe3 || !stripe4) return;
    stripe1.style.width = STRIPES_ANIMATION_CONFIG/* EXPANDED_STRIPE_WIDTH */.o7;
    stripe2.style.width = STRIPES_ANIMATION_CONFIG/* EXPANDED_STRIPE_WIDTH */.o7;
    stripe3.style.width = STRIPES_ANIMATION_CONFIG/* EXPANDED_STRIPE_WIDTH */.o7;
    stripe4.style.width = STRIPES_ANIMATION_CONFIG/* EXPANDED_STRIPE_WIDTH */.o7;
};


/***/ }),

/***/ 9771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useModelStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4529);

const useModelStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        booths: [],
        boothURL: "",
        boothSmallURL: "",
        warehouseURL: "",
        boothRotation: Math.PI,
        warehouseRotation: Math.PI / 2,
        setBooths: (booths)=>set(()=>({
                    booths
                })),
        setBoothURL: (boothURL)=>set(()=>({
                    boothURL
                })),
        setBoothSmallURL: (boothSmallURL)=>set(()=>({
                    boothSmallURL
                })),
        setWarehouseURL: (warehouseURL)=>set(()=>({
                    warehouseURL
                }))
    }));



/***/ })

}]);